import { defaultColumnWidths } from "@/lib/interfaces and Enums/ENUMColumnWidths";
import { ExecutionRequestStatus } from "@/lib/interfaces and Enums/ENUMExecutionRequestStatus";
import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";
import { SecurityTypeCode } from "@/lib/interfaces and Enums/ENUMSecurityTypeCode";
import { StrategyType } from "@/lib/interfaces and Enums/ENUMStrategyType";
import { StructureTypeCode } from "@/lib/interfaces and Enums/ENUMStructureTypeCode";
import { TableHeaderField } from "@/lib/interfaces and Enums/ENUMTableHeaders";
import { TradeType } from "@/lib/interfaces and Enums/ENUMTradeType";
import { fillerColDef } from "@/lib/fillerColDef";
import { returnSizeFormatted } from "@/lib/globalFormatterHelper";
import {
  updateExecutionEditSecurity,
  updateSettlementDate,
} from "@/store/tradeDataStoreACTIONS";
import { ColDef } from "ag-grid-community";
import {
  isCPIEditable,
  isStrikeEditable,
  reorderColumnsForOrders,
  returnColDefsAsNewArray,
  tradeHasBondOrBondOption,
  wrapColDefsForOrderFills,
  getStartFillerWidth,
} from "../actionSummaryColDefHelperFunctions";
import { applyColumnWidthMultiplier } from "../actionSummaryHelper";
import { IColDefsObject } from "../actionSummaryMainTableColDefs";
import { findCPOnTradeByBlockId } from "../tradeLookupHelpers";
import CPICellEditor from "../cellEditors/CPICellEditor";
import StrikeCellEditor from "../cellEditors/StrikeCellEditor";
import BookCellRenderer from "../cellRenderers/BookCellRenderer";
import CashCellRenderer from "../cellRenderers/CashCellRenderer";
import CouponActionSummarySwapCellRenderer from "../cellRenderers/CouponActionSummarySwapCellRenderer";
import { couponCellValueFormatter } from "../cellRenderers/CouponActionSummarySwapCellRenderer/couponActionSummarySwapFormatter";
import CPICellRenderer from "../cellRenderers/CPICellRenderer";
import CpiIndexCellRenderer from "../cellRenderers/CpiIndexCellRenderer";
import DealerCellRenderer from "../cellRenderers/DealerCellRenderer";
import { dealerCellValueFormatter } from "../cellRenderers/dealerCellFormatter";
import { cashCellValueFormatter } from "../cellRenderers/cashCellFormatter";
import { dealtFeeCellValueFormatter } from "../cellRenderers/dealtFeeCellFormatter";
import DealtFeeCellRenderer from "../cellRenderers/DealtFeeCellRenderer";
import DealtPriceCellRenderer from "../cellRenderers/DealtPriceCellRenderer";
import { dealtPriceValueFormatter } from "../cellRenderers/DealtPriceCellRenderer/dealtPriceFormatter";
import {
  CurrentCouponCellRenderer,
  QuotedMarginCellRenderer,
  ReferenceIndexCellRenderer,
} from "../cellRenderers/FRNBlockCellRenderers";
import {
  currentCouponValueFormatter,
  quotedMarginValueFormatter,
  referenceIndexValueFormatter,
} from "../cellRenderers/FRNBlockCellRenderers/frnBlockFormatter";
import DeliveryDateCellRenderer from "../cellRenderers/DeliveryDateCellRenderer";
import { deliveryDateValueFormatter } from "../cellRenderers/DeliveryDateCellRenderer/deliveryDateFormatter";
import { isDeliveryDateEditable } from "../cellRenderers/DeliveryDateCellRenderer/deliveryDateHelpers";
import DirectionCellRenderer from "../cellRenderers/DirectionCellRenderer/index";
import { directionValueFormatter } from "../cellRenderers/DirectionCellRenderer/directionFormatter";
import ExecutionFeeCellRenderer from "../cellRenderers/ExecutionFeeCellRenderer";
import ExpandCollapseAllHeader from "../cellRenderers/ExpandCollapseAllHeader";
import ExpiryDateCellRenderer from "../cellRenderers/ExpiryDateCellRenderer";
import FillExpandCellRenderer from "../cellRenderers/FillExpandCellRenderer";
import FillPriceCellRenderer from "../cellRenderers/FillPriceCellRenderer";
import { fillPriceValueFormatter } from "../cellRenderers/FillPriceCellRenderer/fillPriceFormatter";
import FillQuantityCellRenderer from "../cellRenderers/FillQuantityCellRenderer";
import { fillQuantityValueFormatter } from "../cellRenderers/FillQuantityCellRenderer/fillQuantityFormatter";
import FilledAtCellRenderer from "../cellRenderers/FilledAtCellRenderer";
import { filledAtValueFormatter } from "../cellRenderers/FilledAtCellRenderer/filledAtFormatter";
import FilledPercentCellRenderer from "../cellRenderers/FilledPercentCellRenderer";
import { filledPercentValueFormatter } from "../cellRenderers/FilledPercentCellRenderer/filledPercentFormatter";
import {
  FillsSummaryPercentCellRenderer,
  fillsSummaryPercentValueFormatter,
  FillsSummaryPriceCellRenderer,
  fillsSummaryPriceValueFormatter,
  FillsSummaryQuantityCellRenderer,
  fillsSummaryQuantityValueFormatter,
} from "../cellRenderers/FillsSummary";
import IndicativeMidCellRenderer from "../cellRenderers/IndicativeMidCellRenderer";
import QuotedPercentCellRenderer from "../cellRenderers/QuotedPercentCellRenderer";
import { quotedPercentValueFormatter } from "../cellRenderers/QuotedPercentCellRenderer/quotedPercentFormatter";
import LevelCellRenderer from "../cellRenderers/LevelCellRenderer";
import { levelValueFormatter } from "../cellRenderers/LevelCellRenderer/levelFormatter";
import NotionalLeg1 from "../cellRenderers/NotionalLeg1";
import { notionalLeg1ValueFormatter } from "../cellRenderers/NotionalLeg1/notionalLeg1Formatter";
import { notionalLeg1TooltipValueGetter } from "../cellRenderers/NotionalLeg1/notionalLeg1Tooltip";
import QuoteCellRenderer from "../cellRenderers/QuoteCellRenderer";
import SettlementDateCellRenderer from "../cellRenderers/SettlementDateCellRenderer";
import { settlementDateValueFormatter } from "../cellRenderers/SettlementDateCellRenderer/settlementDateFormatter";
import StrikeCellRenderer from "../cellRenderers/StrikeCellRenderer";
import UnwindTypeCellRenderer from "../cellRenderers/UnwindTypeCellRenderer";
import { returnTrueIfCellCanBeEdited } from "../columnHelpers/cellCanBeEdited";
import { ColId } from "../ENUMActionSummaryColIds";
import { indicativeMidTooltipValueGetter } from "../tooltips/IndicativeMidTooltip";
import {
  displayPendingTooltipForFilledPercent,
  displayPendingTooltipForFillQuantity,
  displayYieldTooltipForAllQuoteLevels,
  displayYieldTooltipForFills,
} from "../tooltips/tooltipHelperFunctions";
import {
  quoteValueFormatter,
  statusAtAffirmedRange,
  statusAtExecutedRange,
  statusFormExecutedToAffirmedRange,
  statusFromAwarded,
  statusToShowDealtPrice,
  tradeHasReducedQuotedSize,
} from "./colDefsShared";
import CashDealerTooltip from "../tooltips/CashDealerTooltip";
import { feeAdjustedYieldTooltipValueGetter } from "../tooltips/FeeAdjustedYieldTooltip";

export function returnLegColDefsOP({
  theme,
  fullTradeData,
  getAccessTokenSilently,
  columnWidthMultiplier = 1.0,
}: IColDefsObject) {
  const isOrder = fullTradeData?.type === TradeType.Order;

  const legColDefsOP = [
    {
      field: "",
      headerName: " ",
      width: defaultColumnWidths.expandArrow,
      fixedWidth: true,
      // cellRenderer: "agGroupCellRenderer",
      cellRenderer: isOrder ? FillExpandCellRenderer : "agGroupCellRenderer",
      resizable: false,
      suppressMovable: true,
      pinned: "left",
      colId: ColId.expand,
      cellClass: "detailExpandCellRendererArrow",
      headerClass: "fixedWidthHeader",
      mainMenuItems: ["resetColumns"],
      cellRendererParams: { fullTradeData: fullTradeData },
      headerComponent: ExpandCollapseAllHeader,
    },
    {
      field: "startFiller",
      colId: ColId.startFiller,
      headerName: " ",
      width: getStartFillerWidth(columnWidthMultiplier), // 0.9→50, 1→53, 1.2→59
      fixedWidth: true,
      resizable: false,
      suppressMovable: true,
      hide: false, // Needed for RP legs to space out the bid / ask / mid.
      lockPosition: "left",
      suppressColumnsToolPanel: true,
      headerClass: "fixedWidthHeader",
      cellClass: "fixedWidthCell",
    },
    {
      field: "bid",
      tooltipValueGetter: displayYieldTooltipForAllQuoteLevels,
      headerName: TableHeaderField.bid,
      colId: ColId.bid,
      width: defaultColumnWidths.quoteField,
      cellClass: "ag-roundedInputStyle",
      cellRendererParams: { fullTradeData: fullTradeData, tableLevel: "Leg" },
      cellRenderer: QuoteCellRenderer,
      valueFormatter: quoteValueFormatter,
    },
    {
      field: "ask",
      tooltipValueGetter: displayYieldTooltipForAllQuoteLevels,
      headerName: TableHeaderField.ask,
      colId: ColId.ask,
      width: defaultColumnWidths.quoteField,
      cellClass: "ag-roundedInputStyle",
      cellRendererParams: { fullTradeData: fullTradeData, tableLevel: "Leg" },
      cellRenderer: QuoteCellRenderer,
      valueFormatter: quoteValueFormatter,
    },
    {
      field: "mid",
      tooltipValueGetter: displayYieldTooltipForAllQuoteLevels,
      headerName: TableHeaderField.mid,
      colId: ColId.mid,
      width: defaultColumnWidths.quoteField,
      cellClass: "ag-roundedInputStyle",
      cellRendererParams: { fullTradeData: fullTradeData, tableLevel: "Leg" },
      cellRenderer: QuoteCellRenderer,
      valueFormatter: quoteValueFormatter,
    },
    {
      field: "feeAdjustedQuote",
      headerName: TableHeaderField.feeAdjustedQuote,
      colId: ColId.feeAdjustedQuote,
      width: defaultColumnWidths.feeAdjustedQuote,
      cellRenderer: DealtPriceCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueFormatter: dealtPriceValueFormatter,
      tooltipValueGetter: feeAdjustedYieldTooltipValueGetter
    },
    {
      field: "unwind",
      headerName: TableHeaderField.unwind,
      extraLargeScaling: true,
      colId: ColId.unwind,
      width: defaultColumnWidths.unwind,
      cellRenderer: UnwindTypeCellRenderer,
      valueFormatter: (params: any) => params.value,
      cellRendererParams: { fullTradeData: fullTradeData },
    },

    {
      field: "dealer",
      headerName: TableHeaderField.dealer,
      colId: ColId.dealer,
      headerClass: "noRightBorder",
      cellRenderer: DealerCellRenderer,
      valueFormatter: dealerCellValueFormatter,
      cellRendererParams: { fullTradeData: fullTradeData, theme: theme },
      width: defaultColumnWidths.dealer,
      tooltipValueGetter: (params: any) => params.data ? "dealer" : null,
      tooltipComponent: CashDealerTooltip,
    },
    {
      field: "cash",
      headerName: TableHeaderField.cash,
      colId: ColId.cash,
      cellRenderer: CashCellRenderer,
      valueFormatter: cashCellValueFormatter,
      cellRendererParams: { fullTradeData: fullTradeData },
      width: defaultColumnWidths.cash,
    },
    {
      field: "executionFee",
      headerName: TableHeaderField.executionFee,
      colId: ColId.executionFee,
      width: defaultColumnWidths.executionFee,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: ExecutionFeeCellRenderer,
    },
    {
      field: "dealtFee", //npv Cash(fee inc),
      headerName: TableHeaderField.dealtFee,
      colId: ColId.dealtFee,
      width: defaultColumnWidths.dealtFee,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: DealtFeeCellRenderer,
      valueFormatter: dealtFeeCellValueFormatter,
      tooltipValueGetter: (params: any) => params.data ? "dealtFee" : null,
      tooltipComponent: CashDealerTooltip,
    },
    // {
    //   field: "indicativeCash",
    //   colId: ColId.indicativeCash,
    //   headerName: TableHeaderField.indicativeCash,
    //   width: defaultColumnWidths.indicativeCash,
    //   cellRenderer: IndicativeCashCellRenderer,
    //   cellRendererParams: { fullTradeData: fullTradeData },
    // },
    {
      field: "dealtStrike",
      headerName: TableHeaderField.dealtStrike,
      width: defaultColumnWidths.strike,
      colId: ColId.strike,
      editable: (params: any) => {
        return isStrikeEditable({
          params: params,
          esid: fullTradeData.esid,
        });
      },
      cellClass: "ag-roundedInputStyle ",
      cellStyle: { padding: "0px" },
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: StrikeCellRenderer,
      cellEditor: StrikeCellEditor,
    },
    // {
    //   field: "dealtStrike",
    //   headerName: TableHeaderField.dealtStrike,
    //   colId: ColId.strike,
    //   width: defaultColumnWidths.nominal,
    //   editable: (params: any) =>
    //     canEditDealtStirke({
    //       structureType: params.data.securityType,
    //       statusPassed: fullTradeData.status,
    //     }),
    //   cellClass: (params: any) => {
    //     return canEditDealtStirke({
    //       structureType: params.data.securityType,
    //       statusPassed: fullTradeData.status,
    //     }) == true
    //       ? theme == "light"
    //         ? "inputCellOtherLight roundedInputCell"
    //         : "inputCellOtherDark roundedInputCell"
    //       : "roundedInputCell";
    //   },

    //   cellRendererParams: { fullTradeData: fullTradeData, tableLevel: "ER" },
    //   cellRenderer: StrikeCellRenderer,
    //   cellEditor: StrikeCellEditor,
    // },
    {
      field: "direction",
      headerName: TableHeaderField.direction,
      colId: ColId.direction,
      width: defaultColumnWidths.side,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: DirectionCellRenderer,
      valueFormatter: directionValueFormatter,
    },
    {
      field: "coupon",
      headerName: TableHeaderField.coupon,
      colId: ColId.coupon,
      width: defaultColumnWidths.coupon,
      cellRenderer: CouponActionSummarySwapCellRenderer,
      valueFormatter: couponCellValueFormatter,
      cellRendererParams: { fullTradeData: fullTradeData },
    },
    {
      field: "notionalLeg1",
      headerName: TableHeaderField.notionalLeg1,
      colId: ColId.notionalLeg1,
      width: defaultColumnWidths.nominal,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: NotionalLeg1,
      valueFormatter: notionalLeg1ValueFormatter,
      tooltipValueGetter: notionalLeg1TooltipValueGetter,
    },
    {
      field: "quotedSize",
      headerName: TableHeaderField.quotedSize,
      colId: ColId.quotedSize,
      width: defaultColumnWidths.quotedSize,
      cellRenderer: (params: any) => {
        return params.value
          ? returnSizeFormatted(params.value, params.data.instrumentType)
          : "";
      },
    },
    {
      // % Quoted bar — hide: true so unselected paths
      // (returnColDefsAsNewArray's fallback) don't surface the column;
      // selection arrays gated by tradeHasReducedQuotedSize override with hide: false.
      field: "quotedSize",
      headerName: TableHeaderField.percentQuoted,
      colId: ColId.percentQuoted,
      width: defaultColumnWidths.percentQuoted,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: QuotedPercentCellRenderer,
      valueFormatter: quotedPercentValueFormatter,
      hide: true,
    },
    {
      field: "security",
      headerName: TableHeaderField.security,
      colId: ColId.security,
      width: defaultColumnWidths.name,
      // flex: 2,
      tooltipField: "isin",
    },
    // LQC-2153: FRN columns sit after Security - visibility controlled by additionalColDefs
    {
      field: "referenceIndex",
      headerName: TableHeaderField.referenceIndex,
      colId: ColId.referenceIndex,
      width: defaultColumnWidths.referenceIndex,
      cellRenderer: ReferenceIndexCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueFormatter: referenceIndexValueFormatter,
    },
    {
      field: "quotedMargin",
      headerName: TableHeaderField.quotedMargin,
      colId: ColId.quotedMargin,
      width: defaultColumnWidths.quotedMargin,
      cellRenderer: QuotedMarginCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueFormatter: quotedMarginValueFormatter,
    },
    {
      field: "coupon", // FRN Current Coupon reuses the block coupon
      headerName: TableHeaderField.currentCoupon,
      colId: ColId.currentCoupon,
      width: defaultColumnWidths.currentCoupon,
      cellRenderer: CurrentCouponCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueFormatter: currentCouponValueFormatter,
    },
    // LQC-227: ISIN column for bond trades — visibility controlled by selection arrays
    {
      field: "isin",
      headerName: "ISIN",
      colId: ColId.isin,
      width: 150,
    },
    {
      field: "settlementDate",
      headerName: TableHeaderField.settlementDate,
      colId: ColId.settlementDate,
      extraScaling: true,
      width: defaultColumnWidths.date,
      editable: (params: any) =>
        returnTrueIfCellCanBeEdited(params.data.statusER),
      valueSetter: (params: any) => {
        const erid = findCPOnTradeByBlockId(fullTradeData, params.data.blockId);

        updateSettlementDate(
          fullTradeData.esid,
          erid.executionRequestId,
          params.data.blockId,
          params.newValue,
          getAccessTokenSilently,
        );
      },
      cellRenderer: SettlementDateCellRenderer,
      cellStyle: { padding: "0px" },
      cellClass: "ag-roundedInputStyle",
      cellRendererParams: { fullTradeData },
      valueFormatter: settlementDateValueFormatter,
      cellDataType: "dateString",
    },
    // ORDER - Start
    {
      field: "referencePrice", // Order
      headerName: TableHeaderField.level,
      colId: ColId.level,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: LevelCellRenderer,
      valueFormatter: levelValueFormatter,
      width: defaultColumnWidths.level,
    },
    {
      field: "referenceSpread", // Order
      headerName: TableHeaderField.refSpread,
      colId: ColId.refAsset,
      width: defaultColumnWidths.refAsset,
    },
    {
      field: "referenceAsset", // Order
      headerName: TableHeaderField.refAsset,
      colId: ColId.refAsset,
      width: defaultColumnWidths.refAsset,
    },
    // {
    //   field: "minClip", // Only minClip
    //   headerName: TableHeaderField.minClip,
    //   colId: ColId.minClip,
    //   width: defaultColumnWidths.minClip,
    // },
    {
      field: "fillQuantity", // Order
      headerName: TableHeaderField.fillQuantity,
      colId: ColId.fillQuantity,
      width: defaultColumnWidths.fillQuantity,
      cellRenderer: FillsSummaryQuantityCellRenderer,
      tooltipValueGetter: displayPendingTooltipForFillQuantity,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueFormatter: fillsSummaryQuantityValueFormatter,
    },
    {
      field: "fillPrice", // Order
      headerName: TableHeaderField.fillPrice,
      colId: ColId.fillPrice,
      width: defaultColumnWidths.fillPrice,
      cellRenderer: FillsSummaryPriceCellRenderer,
      tooltipValueGetter: displayYieldTooltipForFills,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueFormatter: fillsSummaryPriceValueFormatter,
    },
    {
      field: "filledPercent", // Order
      headerName: TableHeaderField.filledPercent,
      colId: ColId.filledPercent,
      width: defaultColumnWidths.filledPercent,
      cellRenderer: FillsSummaryPercentCellRenderer,
      tooltipValueGetter: displayPendingTooltipForFilledPercent,
      cellRendererParams: { fullTradeData: fullTradeData },
      valueFormatter: fillsSummaryPercentValueFormatter,
    },
    {
      field: "filledAt", // Order
      headerName: TableHeaderField.filledAt,
      colId: ColId.filledAt,
      width: defaultColumnWidths.filledAt,
      cellStyle: { textAlign: "center" },
    },
    // ORDER - End
    {
      field: "expiryDate",
      colId: ColId.expiryDate,
      headerName: TableHeaderField.expiryDate,
      width: defaultColumnWidths.date,
      cellRenderer: ExpiryDateCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
    },
    {
      field: "deliveryDate",
      headerName: TableHeaderField.deliveryDate,
      colId: ColId.deliveryDate,
      width: defaultColumnWidths.date,
      editable: (params: any) =>
        isDeliveryDateEditable(params.data.statusER, params.data.securityType),
      cellRenderer: DeliveryDateCellRenderer,
      cellStyle: { padding: "0px" },
      cellClass: "ag-roundedInputStyle",
      cellRendererParams: { fullTradeData },
      valueFormatter: deliveryDateValueFormatter,
      valueSetter: (params: any) => {
        const erid = findCPOnTradeByBlockId(fullTradeData, params.data.blockId);
        updateExecutionEditSecurity({
          esid: fullTradeData.esid,
          erid: erid.executionRequestId,
          blockid: params.data.blockId,
          deliveryDate: params.newValue,
          dealtStrike: params.data.dealtStrike,
          getAccessTokenSilently: getAccessTokenSilently,
        });
      },
      cellDataType: "dateString",
    },
    {
      field: "extStructureId",
      headerName: TableHeaderField.extStructureId,
      colId: ColId.extStructureId,
      extraScaling: true,
      width: defaultColumnWidths.extStructureId,
    },
    {
      field: "cpi",
      headerName: TableHeaderField.cpiLeg1,
      colId: ColId.cpiLeg1,
      width: defaultColumnWidths.cpi,
      editable: (params: any) =>
        isCPIEditable({
          esid: fullTradeData.esid,
          securityType: params.data.securityType,
        }),
      cellStyle: { padding: "0px" },
      cellClass: "ag-roundedInputStyle",
      cellRenderer: CPICellRenderer,
      cellEditor: CPICellEditor,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellDataType: "number",
    },
    {
      field: "cpiIndex",
      headerName: TableHeaderField.cpiIndex,
      colId: ColId.cpiIndex,
      width: defaultColumnWidths.cpiIndex,
      cellRendererParams: { fullTradeData: fullTradeData },
      cellRenderer: CpiIndexCellRenderer,
    },
    {
      field: "indicativeMid",
      headerName: TableHeaderField.indicativeMid,
      colId: ColId.indicativeMid,
      width: defaultColumnWidths.indicativeMid,
      cellRenderer: IndicativeMidCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
      tooltipValueGetter: indicativeMidTooltipValueGetter,
    },
    {
      field: "notionalLeg2",
      headerName: TableHeaderField.notionalLeg2,
      colId: ColId.notionalLeg2,
      width: defaultColumnWidths.nominal,
      cellRenderer: (params: any) => {
        return params.value
          ? returnSizeFormatted(params.value, params.data.instrumentType)
          : "";
      },
    },
    {
      field: "book",
      headerName: TableHeaderField.book,
      colId: ColId.book,
      width: defaultColumnWidths.book,
      cellRenderer: BookCellRenderer,
      cellRendererParams: { fullTradeData: fullTradeData },
    },
    ...fillerColDef,
  ];

  const structureType = fullTradeData.structureType;
  const status = fullTradeData.status;
  const type = fullTradeData.type;
  const unwind = fullTradeData.unwind;

  let containsRecoupon = false;
  let containsNPV = false;
  if (
    fullTradeData.executionRequestCounterParties &&
    fullTradeData.executionRequestCounterParties.length > 0
  ) {
    fullTradeData.executionRequestCounterParties[0].legs.forEach((leg: any) => {
      if (leg.unwind == "Recoupon") {
        containsRecoupon = true;
      }
      if (leg.unwind == "NPV") {
        containsNPV = true;
      }
    });
  }

  let colDefsToReturn: ColDef | any = [];
  const columnsToShowForNPVorRecoupon: ColId[] = []; // USED FOR NPV / Recoupon to prevent cols later getting added.
  const columnsToHideForNPVorRecoupon: ColId[] = []; // USED FOR NPV / Recoupon to prevent cols later getting added.

  const dealtPriceCols: any[] = [];
  if (statusToShowDealtPrice.includes(status)) {
    dealtPriceCols.push(ColId.feeAdjustedQuote);
    // ADD FOR NPVS Too
    columnsToShowForNPVorRecoupon.push(ColId.feeAdjustedQuote);
  }
  const bookCols: any[] = [];
  if (statusFromAwarded.includes(status)) {
    bookCols.push(ColId.book);
  }

  if (!unwind) {
    if (containsNPV || containsRecoupon) {
      columnsToShowForNPVorRecoupon.push(ColId.unwind);
    }
  }

  if (type == "RFQ") {
    // if (structureType == StructureTypeCode.NPVPACK) {
    if (unwind == true) {
      // FOR ALL STATUS' - Hide the bid ask and mid
      // 14170, 14231, 14239 - HIDE NPV Style
      columnsToHideForNPVorRecoupon.push(
        ColId.bid,
        ColId.bidOutright,
        ColId.ask,
        ColId.askOutright,
        ColId.mid,
        ColId.midOutright,
        ColId.feeAdjustedQuote,
      );
      // Start status specific SHOWING NPV Style.
      if (!statusFormExecutedToAffirmedRange.includes(status)) {
        // 14170 - SHOW NPV Style
        columnsToShowForNPVorRecoupon.push(ColId.coupon, ColId.indicativeCash); //Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
      } else if (statusAtExecutedRange.includes(status)) {
        // 14231 - SHOW NPV Style - Block
        columnsToShowForNPVorRecoupon.push(
          ColId.dealer,
          ColId.cash,
          ColId.executionFee,
          ColId.coupon,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
        );
      } else if (statusAtAffirmedRange.includes(status)) {
        // 14239 - SHOW NPV STYLE Blocks
        columnsToShowForNPVorRecoupon.push(
          ColId.dealer,
          ColId.dealtFee,
          ColId.coupon,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
        );
      } else {
        columnsToShowForNPVorRecoupon.push(ColId.coupon);
      }
    } else if (unwind == false && containsNPV) {
      // let colsForNPVOPLeg: ColId[] = [];

      if (!statusFormExecutedToAffirmedRange.includes(status)) {
        // 14281 - Add cols for NPV
        columnsToShowForNPVorRecoupon.push(
          ColId.coupon,
          ColId.dealer,
          ColId.cash,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
        );
      } else if (statusAtExecutedRange.includes(status)) {
        columnsToShowForNPVorRecoupon.push(
          ColId.coupon,
          ColId.dealer,
          ColId.cash,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
          ColId.executionFee,
          ColId.feeAdjustedQuote,
        );
      } else if (statusAtAffirmedRange.includes(status)) {
        columnsToShowForNPVorRecoupon.push(
          ColId.coupon,
          ColId.dealer,
          ColId.dealtFee,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
        );
      }
    }

    // Handle Repoupons
    if (unwind == false && containsRecoupon) {
      if (
        statusAtExecutedRange.includes(status) ||
        status == ExecutionRequestStatus.Awarded // #14876, #14877, #14878, #14879, #14880, #14881 - Moving ReCoupon showing on Dealer and Cash cells forward to Awarded.
      ) {
        // 14247 SHOW OP LEG RECOUPON
        columnsToShowForNPVorRecoupon.push(
          ColId.coupon,
          ColId.dealer,
          ColId.cash,
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
        );
        if (statusAtExecutedRange.includes(status)) {
        }
        if (statusAtExecutedRange.includes(status)) {
          columnsToShowForNPVorRecoupon.push(ColId.executionFee);
        }
        // 14247 HIDE OP LEG RECOUPON
        // columnsToHideForNPVorRecoupon.push(
        //   ColId.feeAdjustedQuote, // Dealt price.
        // );
      } else if (statusAtAffirmedRange.includes(status)) {
        // 14254 SHOW OP LEG RECOUPON
        columnsToShowForNPVorRecoupon.push(
          ColId.coupon,
          ColId.dealer,
          ColId.dealtFee, // "Cash (fee inc.)"
          ColId.indicativeCash, // Check? 14913, 14915, 14917, 14300 - New indicativeCashCell
          ColId.feeAdjustedQuote, // Dealt price.
        );
        // 14254 HIDE none.
      }
      // else {
      //   columnsToHideForNPVorRecoupon.push(
      //     ColId.feeAdjustedQuote, // Dealt price.
      //   );
      // }
    }

    if (
      structureType == StructureTypeCode.SYNREPO ||
      structureType == StructureTypeCode.SYNREVREP
    ) {
      if (statusFormExecutedToAffirmedRange.includes(status)) {
        if (statusAtExecutedRange.includes(status)) {
          const colsForSynAtExecutedRange = [
            ColId.direction,
            ColId.notionalLeg1,
            ColId.security,
            ...(tradeHasBondOrBondOption(fullTradeData) ? [ColId.isin] : []),
            ColId.settlementDate,
            ColId.expiryDate,
            ColId.deliveryDate,
            ColId.bid,
            ColId.ask,
            ColId.mid,
            ColId.indicativeMid,
            ColId.strike,
            ColId.quotedSize,
            ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuoted] : []),
            ...bookCols,
            ...dealtPriceCols,
          ];
          colDefsToReturn = returnColDefsAsNewArray(
            legColDefsOP,
            colsForSynAtExecutedRange,
            columnsToShowForNPVorRecoupon,
            columnsToHideForNPVorRecoupon,
          );
        } else if (statusAtAffirmedRange.includes(status)) {
          const colsForSynAtAffirmedRange = [
            ColId.direction,
            ColId.notionalLeg1,
            ColId.security,
            ...(tradeHasBondOrBondOption(fullTradeData) ? [ColId.isin] : []),
            ColId.settlementDate,
            ColId.expiryDate,
            ColId.deliveryDate,
            ColId.bid,
            ColId.ask,
            ColId.mid,
            ColId.indicativeMid,
            ColId.strike,
            ColId.quotedSize,
            ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuoted] : []),
            ...bookCols,
            ...dealtPriceCols,
          ];

          colDefsToReturn = returnColDefsAsNewArray(
            legColDefsOP,
            colsForSynAtAffirmedRange,
            columnsToShowForNPVorRecoupon,
            columnsToHideForNPVorRecoupon,
          );
        }
      } else {
        // Cols before affirmed and executed status'
        const colsForSynAtStartRange = [
          ColId.direction,
          ColId.notionalLeg1,
          ColId.security,
          ...(tradeHasBondOrBondOption(fullTradeData) ? [ColId.isin] : []),
          ColId.settlementDate,
          ColId.expiryDate,
          ColId.deliveryDate,
          ColId.indicativeMid,
          ColId.quotedSize,
          ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuoted] : []),
          ...bookCols,
          ...dealtPriceCols,
        ];
        colDefsToReturn = returnColDefsAsNewArray(
          legColDefsOP,
          colsForSynAtStartRange,
          columnsToShowForNPVorRecoupon,
          columnsToHideForNPVorRecoupon,
        );
      }
    } else {
      const additionalColDefs: any[] = [];
      fullTradeData.executionRequestCounterParties[0].legs.forEach(
        (leg: any) => {
          const securityType = leg.securityType;
          const instrumentType = leg.instrumentType;
          if (
            securityType == SecurityTypeCode.SWO ||
            securityType == SecurityTypeCode.BNDO
          ) {
            additionalColDefs.push(ColId.strike); // dealtStrike but colId of strike
          }
          if (securityType == SecurityTypeCode.ZCS) {
            additionalColDefs.push(ColId.cpiLeg1, ColId.cpiIndex);
          }
          if (
            securityType == SecurityTypeCode.XCS ||
            securityType == SecurityTypeCode.XBS
          ) {
            additionalColDefs.push(ColId.notionalLeg2);
          }

          if (instrumentType == InstrumentTypeCode.OPT) {
            additionalColDefs.push(ColId.expiryDate);
          }

          //FRN Columns
          if(instrumentType == InstrumentTypeCode.FRN){
            additionalColDefs.push(ColId.referenceIndex, ColId.quotedMargin, ColId.currentCoupon) //reference index, quoted margin, current coupon
          }
        },
      );

      const colsForDefaultOPLeg = [
        ColId.direction,
        ColId.notionalLeg1,
        ColId.security,
        ...(tradeHasBondOrBondOption(fullTradeData) ? [ColId.isin] : []),
        ColId.settlementDate,
        ColId.bid,
        ColId.ask,
        ColId.mid,
        ColId.indicativeMid,
        ColId.quotedSize,
        ...(tradeHasReducedQuotedSize(fullTradeData) ? [ColId.percentQuoted] : []),
        ...bookCols,
        ...additionalColDefs,
        ...dealtPriceCols,
      ];
      colDefsToReturn = returnColDefsAsNewArray(
        legColDefsOP,
        colsForDefaultOPLeg,
        columnsToShowForNPVorRecoupon,
        columnsToHideForNPVorRecoupon,
      );
    }
  } else if (type == "Order") {
    const colsForOrderOPLeg = [
      ColId.expand,
      ColId.direction,
      ColId.notionalLeg1,
      ColId.security,
      ...(tradeHasBondOrBondOption(fullTradeData) ? [ColId.isin] : []),
      ColId.settlementDate,
      ColId.level,
      ColId.fillQuantity,
      ColId.filledPercent,
      ColId.filledAt,
      ColId.fillPrice,
      ...dealtPriceCols,
      ...bookCols,
    ];
    //  keeping Orders the same as RFQs - Only show indicativeMid for structures
    if (fullTradeData.strategyType !== StrategyType.Outright) {
      colsForOrderOPLeg.push(ColId.indicativeMid);
    }

    const tradeHasFRNLeg = fullTradeData.executionRequestCounterParties?.[0]?.legs?.some(
      (leg: any) => leg.instrumentType == InstrumentTypeCode.FRN,
    );
    if (tradeHasFRNLeg) {
      colsForOrderOPLeg.push(
        ColId.referenceIndex,
        ColId.quotedMargin,
        ColId.currentCoupon,
      );
    }

    colDefsToReturn = returnColDefsAsNewArray(
      legColDefsOP,
      colsForOrderOPLeg,
      columnsToShowForNPVorRecoupon,
      columnsToHideForNPVorRecoupon,
      true, // order - Will remove the filler column.
    );

    // Reorder dealtPrice to appear after filledAt (Actioned At) for Orders
    colDefsToReturn = reorderColumnsForOrders(colDefsToReturn, [
      { colId: ColId.feeAdjustedQuote, afterColId: ColId.fillPrice },
    ]);

    // Wrap columns for flattened fills (block rows show summary, fill rows show individual)
    const dualColumnMapOP = new Map<
      string,
      {
        fillRenderer: any;
        fillFormatter?: any;
        fillValueGetter?: (params: any) => any;
      }
    >([
      [
        ColId.fillQuantity,
        {
          fillRenderer: FillQuantityCellRenderer,
          fillFormatter: fillQuantityValueFormatter,
          fillValueGetter: (params: any) => params.data?.fillData?.fillSize,
        },
      ],
      [
        ColId.fillPrice,
        {
          fillRenderer: FillPriceCellRenderer,
          fillFormatter: fillPriceValueFormatter,
          fillValueGetter: (params: any) => params.data?.fillData?.fillRate,
        },
      ],
      [
        ColId.filledPercent,
        {
          fillRenderer: FilledPercentCellRenderer,
          fillFormatter: filledPercentValueFormatter,
        },
      ],
      [
        ColId.filledAt,
        {
          fillRenderer: FilledAtCellRenderer,
          fillFormatter: filledAtValueFormatter,
        },
      ],
    ]);

    colDefsToReturn = wrapColDefsForOrderFills(
      colDefsToReturn,
      dualColumnMapOP,
      [], // OP has no fill-only columns (no Remove/Edit buttons)
      fullTradeData,
    );
  }
  return applyColumnWidthMultiplier(colDefsToReturn, columnWidthMultiplier);
}
